var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container comparison"},[_c('div',{staticClass:"tables"},[_c('TableCard',{attrs:{"elements":_vm.$t('commonCtSystem')}},[_vm._v(" "+_vm._s(_vm.$t('titleCommonCtSystems'))+" ")]),_c('TableCard',{attrs:{"elements":_vm.$t('vetorixCtSystem')}},[_vm._v(" "+_vm._s(_vm.$t('titleVetorixCtSystems'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }